module.exports = __webpack_public_path__ + "static/media/whatsapp.4dcafd8c.png";